import { Flex, Text } from '@chakra-ui/react';
import React, { useMemo } from 'react';

import { colors } from 'packages/common-frontend/colors';
import { Icon } from 'packages/common-frontend/components/icons';
import { InvoiceComputedStatus } from 'packages/invoices/ui/utils';

type InvoiceBadgeDetails = {
  label: string;
  backgroundColor: string;
  textColor: string;
  icon: string;
};

export const invoiceStatusMap: Record<
  InvoiceComputedStatus,
  InvoiceBadgeDetails
> = {
  created: {
    label: 'Created',
    backgroundColor: colors.blue[50],
    textColor: colors.blue[500],
    icon: 'calendar-clock',
  },
  scheduled: {
    label: 'Scheduled',
    backgroundColor: colors.blue[50],
    textColor: colors.blue[500],
    icon: 'calendar-clock',
  },
  dueSoon: {
    label: 'Due Soon',
    backgroundColor: colors.orange[50],
    textColor: colors.orange[400],
    icon: 'calendar-clock',
  },
  overdue: {
    label: 'Overdue',
    backgroundColor: colors.red[50],
    textColor: colors.red[400],
    icon: 'calendar-clock',
  },
  paid: {
    label: 'Paid',
    backgroundColor: colors.green[50],
    textColor: colors.green[400],
    icon: 'circle-check',
  },
  canceled: {
    label: 'Canceled',
    backgroundColor: colors.gray[50],
    textColor: colors.gray[500],
    icon: 'circle-check',
  },
};

type InvoiceStatusBadgeProps = {
  computedStatus: InvoiceComputedStatus;
  useBackgroundColors?: boolean;
};
export const InvoiceStatusBadge = ({
  computedStatus,
  useBackgroundColors = true,
}: InvoiceStatusBadgeProps) => {
  const invoiceBadgeDetails: InvoiceBadgeDetails = useMemo(() => {
    return invoiceStatusMap[computedStatus];
  }, [computedStatus]);

  return (
    <Flex
      backgroundColor={
        useBackgroundColors ? invoiceBadgeDetails.backgroundColor : undefined
      }
      borderRadius="8px"
      p="8px 16px"
      h="40px"
      w="fit-content"
      alignItems="center"
      cursor="default"
    >
      <Icon
        icon={invoiceBadgeDetails.icon}
        color={invoiceBadgeDetails.textColor}
      />
      <Text color={invoiceBadgeDetails.textColor} ml="16px" fontWeight={500}>
        {invoiceBadgeDetails.label}
      </Text>
    </Flex>
  );
};
